import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ICombineHsaFileResponseDto } from '@/dtos';

interface Params {
  employeeId: string;
  file: File;
}

export const useCombineHSADocumentUploadQuery = () => {
  const { mutateAsync, isPending } = useMutation(({ employeeId, file }: Params) => {
    const formData = new FormData();
    formData.append('file', file);

    return api.post<ICombineHsaFileResponseDto>(
      API_URL.COMBINE_HSA_FILE_UPLOAD,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { 'employee-id': employeeId },
      }
    );
  });

  return {
    combineHSADocumentUpload: mutateAsync,
    isLoading: isPending,
  };
};
